<template>
  <v-row dense align="center" class="mb-0 filtre-comenzi-row">
    <!-- Select Categorie -->
    <v-col cols="12" sm="4">
      <DxSelectBox
        v-model="selectedCategory"
        :items="categories"
        display-expr="Denumire"
        value-expr="TipComanda"
        placeholder="Categorie"
        :search-enabled="true"
        search-expr="Denumire"
      />
    </v-col>

    <!-- Data Start -->
    <v-col cols="12" sm="2">
      <DxDateBox
        v-model="dataStart"
        type="date"
        display-format="yyyy-MM-dd"
        show-clear-button="true"
        placeholder="Start"
      />
    </v-col>

    <!-- Data End -->
    <v-col cols="12" sm="2">
      <DxDateBox
        v-model="dataEnd"
        type="date"
        display-format="yyyy-MM-dd"
        show-clear-button="true"
        placeholder="End"
        :min="dataStart"
      />
    </v-col>

    <!-- Buton Cauta -->
    <v-col cols="12" sm="2">
      <v-btn color="red darken-1" class="mt-0" @click="applyFilters" small>
        Caută
      </v-btn>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import DxDateBox from "devextreme-vue/date-box";
import DxSelectBox from "devextreme-vue/select-box";
import ProComenziService from "@/services/Comercial/ProComenzi";

interface Filter {
  category: number | null;
  start: string;
  end: string;
}

const emit = defineEmits<{
  (e: "filtersChanged", filters: Filter): void;
}>();

const STORAGE_KEY = 'filtre-comenzi';

function loadSaved(): { category: number | null; start: Date | null; end: Date | null } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { category: null, start: null, end: null };
    const parsed = JSON.parse(raw);
    return {
      category: parsed.category ?? null,
      start: parsed.start ? new Date(parsed.start) : null,
      end: parsed.end ? new Date(parsed.end) : null,
    };
  } catch {
    return { category: null, start: null, end: null };
  }
}

function savedOrDefault() {
  const saved = loadSaved();
  const now = new Date();
  return {
    category: saved.category,
    start: saved.start ?? new Date(now.getFullYear(), now.getMonth(), 1),
    end: new Date(),
  };
}

const initial = savedOrDefault();
const selectedCategory = ref<number | null>(initial.category);
const categories = ref<any[]>([]);
const dataStart = ref<Date | null>(initial.start);
const dataEnd = ref<Date | null>(initial.end);


// Funcție de formatare ISO yyyy-MM-dd
function formatDate(d: Date | null) {
  return d ? d.toISOString().split("T")[0] : "";
}

// Emitere filtre
function applyFilters() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    category: selectedCategory.value,
    start: dataStart.value?.toISOString() ?? null,
    end: dataEnd.value?.toISOString() ?? null,
  }));
  emit("filtersChanged", {
    category: selectedCategory.value !== null ? Number(selectedCategory.value) : null,
    start: formatDate(dataStart.value),
    end: formatDate(dataEnd.value),
  });
}

// Încărcare categorii + aplicare filtre implicite
onMounted(async () => {
  const resp = await ProComenziService.getCategoriiPermise();
  categories.value = resp.data ?? [];
  if (selectedCategory.value === null && categories.value.length > 0)
    selectedCategory.value = categories.value[0].TipComanda;
  applyFilters();
});
</script>

<style scoped>
.filtre-comenzi-row :deep(.dx-texteditor-input) {
  height: 26px !important;
  min-height: unset !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
  font-size: 12px !important;
}

.filtre-comenzi-row :deep(.dx-texteditor) {
  height: 26px !important;
}

.filtre-comenzi-row :deep(.dx-placeholder) {
  font-size: 12px !important;
  padding-top: 3px !important;
}

.filtre-comenzi-row :deep(.dx-dropdowneditor-icon),
.filtre-comenzi-row :deep(.dx-clear-button-area) {
  height: 26px !important;
  width: 26px !important;
}

.filtre-comenzi-row .v-btn {
  height: 26px !important;
  font-size: 12px !important;
}
</style>
